exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vs-popup{\n  width: 80% !important;\n}\n", ""]);

// exports
